"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const styles = {
  component: {
    button: {
      stateDisabled: {
        opacity: 0.5
      },
      sizeXs: {
        rounding: '0.25rem'
      },
      sizeSm: {
        rounding: '0.375rem'
      },
      sizeMd: {
        rounding: '0.375rem'
      },
      sizeLg: {
        rounding: '0.375rem'
      },
      sizeXl: {
        rounding: '0.375rem'
      }
    },
    card: {
      sizeSm: {
        rounding: '0.75rem'
      },
      sizeMd: {
        rounding: '1.5rem'
      },
      header: {
        borderWidth: '0.0625rem'
      },
      footer: {
        borderWidth: '0.0625rem'
      }
    },
    chip: {
      stateDisabled: {
        opacity: 0.5
      },
      rounding: '999px'
    },
    divider: {
      thickness: '0.0625rem',
      rounding: '999px'
    },
    focusRing: '0rem 0rem 0rem 0.125rem hsl(0, 0%, 100%), 0rem 0rem 0rem 0.375rem hsl(254, 70%, 62%), 0rem 0rem 0rem 0.4375rem hsl(0, 0%, 100%)'
  },
  backgroundBlur: {
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem'
  },
  borderWidth: {
    sm: '0.0625rem',
    md: '0.125rem',
    lg: '0.25rem'
  },
  opacity: {
    '0': 0,
    '100': 0.1,
    '200': 0.2,
    '500': 0.5,
    '700': 0.7,
    '850': 0.85,
    '950': 0.95
  },
  rounding: {
    none: '0rem',
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.75rem',
    xl: '1.5rem',
    xxl: '2.5rem',
    pill: '999px',
    circle: '50%'
  },
  shadow: {
    subtle: {
      xs: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 1px 2px 0px hsla(206, 48%, 24%, 0.1)',
      sm: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 2px 4px 0px hsla(206, 48%, 24%, 0.1)',
      md: '0px 1px 4px 0px hsla(206, 48%, 24%, 0.1), 0px 6px 12px 0px hsla(206, 48%, 24%, 0.1)',
      lg: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 12px 16px 0px hsla(206, 48%, 24%, 0.1)'
    },
    regular: {
      xs: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.2), 0px 1px 2px 0px hsla(206, 48%, 24%, 0.2)',
      sm: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.2), 0px 2px 4px 0px hsla(206, 48%, 24%, 0.2)',
      md: '0px 1px 4px 0px hsla(206, 48%, 24%, 0.2), 0px 6px 12px 0px hsla(206, 48%, 24%, 0.2)',
      lg: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.2), 0px 12px 16px 0px hsla(206, 48%, 24%, 0.2)'
    },
    dark: {
      xs: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.5), 0px 1px 2px 0px hsla(206, 48%, 24%, 0.5)',
      sm: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.5), 0px 2px 4px 0px hsla(206, 48%, 24%, 0.5)',
      md: '0px 1px 4px 0px hsla(206, 48%, 24%, 0.5), 0px 6px 12px 0px hsla(206, 48%, 24%, 0.5)',
      lg: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.5), 0px 12px 16px 0px hsla(206, 48%, 24%, 0.5)'
    },
    elevation: {
      sunken: '0px 0px 0px 0px transparent',
      flat: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 1px 2px 0px hsla(206, 48%, 24%, 0.1), 0px 0px 0px 1px hsla(205, 25%, 53%, 0.2)',
      raised: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 2px 4px 0px hsla(206, 48%, 24%, 0.1), 0px 0px 0px 1px hsla(205, 25%, 53%, 0.2)',
      floating: '0px 1px 1px 0px hsla(206, 48%, 24%, 0.1), 0px 12px 16px 0px hsla(206, 48%, 24%, 0.1), 0px 0px 0px 1px hsla(205, 25%, 53%, 0.2)'
    }
  }
};
var _default = exports.default = styles;